import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_USER,
  storeGet,
} from 'mailup-react-helpers'

import { beEngagementApiGetEngagement } from 'Api/beEngagementApiTS'

import { beAccountSettingsApiSendContactRequest } from 'Api/beAccountSettingsApi'

import { isNullOrEmpty } from 'Helpers/strings'
import type {
  EngagementItem,
  EngagementScore,
  SearchResult,
} from 'Pages/RecipientsList/model'

export const fetchRecipientsEngagement = async (
  items: SearchResult[],
): Promise<EngagementItem[]> => {
  if (items.length === 0) {
    return []
  }

  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const Ids = items.map((o) => o.Id)

  const results = await beEngagementApiGetEngagement(idList, { Ids })

  const r: EngagementItem[] = items.map(({ Id, Email }) => {
    //  SMS only
    if (isNullOrEmpty(Email)) {
      return {
        idRecipient: Id,
        score: 'Abandoned',
      }
    }

    const res = results.find((o) => o.IdOptin === Id)

    //  No record
    if (res === undefined) {
      return {
        idRecipient: Id,
        score: 'New',
      }
    }

    return {
      idRecipient: Id,
      score: ratingToStars(res.Rating),
    }
  })

  return r
}

export const ratingToStars = (rating: number | null): EngagementScore => {
  if (rating === null) {
    return 'Abandoned'
  } else if (rating >= 16) {
    return 'VeryActive'
  } else if (rating >= 11) {
    return 'Active'
  } else if (rating >= 6) {
    return 'LessActive'
  } else {
    return 'Inactive'
  }
}

export const fetchRecipientEngagement = async (
  idRecipient: number,
  email: SearchResult['Email'],
): Promise<EngagementScore> => {
  if (isNullOrEmpty(email)) {
    return 'Abandoned'
  }

  const idList: number = storeGet(STORE_KEY_ID_LIST)
  const res = await beEngagementApiGetEngagement(idList, { Ids: [idRecipient] })

  if (Array.isArray(res) && res.length > 0) {
    return ratingToStars(res[0].Rating)
  }

  return 'New'
}

export const getUserEmail = async (): Promise<string> => {
  const { RecoverEmail } = storeGet(STORE_KEY_USER)

  return RecoverEmail ?? ''
}

export const sendContactRequest = async (
  email: string,
  title: string,
  description: string,
): Promise<void> => {
  const { Id }: { Id: number } = storeGet(STORE_KEY_ACCOUNT)

  await beAccountSettingsApiSendContactRequest({
    Title: title.replace('#ID#', `${Id}`),
    Description: description.replace('#EMAIL#', email),
  })
}
